import { createSelector } from '@reduxjs/toolkit';
import { Car } from '@lib/azgaz-ui/connect';
import getCatalogGradeByCar from './getCatalogGradeByCar';
import { State } from '../apps/appCreator/store';

type TBrandCar = Car & {
  _original: {
    specification: {
      dealer_discount: number;
      drive: string;
      engine: string;
      generation: number;
      model_category_code: string;
      transmission: string;
    };
  };
};

const getCarOptions = createSelector(
  getCatalogGradeByCar,
  (state: State, car: Car | undefined) => {
    if (!car) return undefined;

    const {
      _original: { specification },
    } = car as TBrandCar;

    return specification;
  },
  (grade, spec) => {
    if (!spec) return undefined;

    return grade?.versions.find(
      version =>
        version.driveType === spec.drive &&
        version.engine.volumetext === spec.engine &&
        version.transmission.transmissiontype === spec.transmission
    );
  }
);

export default getCarOptions;
